export const updateUserAvatar = (image, setState) => {
  setState(prevState => ({
    ...prevState,
    user: {
      ...prevState.user,
      avatar: image,
    },
  }))
}
